//  src/contexts/PriceCategoryContext.jsx
import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchWithRetry } from '../utils/fetchWithRetry';

export const PriceCategoryContext = createContext();

export const PriceCategoryProvider = ({ children }) => {
  const [priceCategories, setPriceCategories] = useState([]);
  const [loadingPriceCategories, setLoadingPriceCategories] = useState(true);
  const [errorPriceCategories, setErrorPriceCategories] = useState(null);

  const PRICE_CATEGORIES_API_URL =
    process.env.REACT_APP_API_BASE_URL + '/items/Preiskategorien?fields=*';

  useEffect(() => {
    const ac = new AbortController();
    const fetchPriceCategories = async () => {
      setLoadingPriceCategories(true); setErrorPriceCategories(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(PRICE_CATEGORIES_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        setPriceCategories(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setErrorPriceCategories('Fehler beim Laden der Preiskategorien');
      } finally {
        if (!ac.signal.aborted) setLoadingPriceCategories(false);
      }
    };
    fetchPriceCategories();
    /* return () => ac.abort(); */
  }, []);

  return (
    <PriceCategoryContext.Provider value={{ priceCategories, loadingPriceCategories, errorPriceCategories }}>
      {children}
    </PriceCategoryContext.Provider>
  );
};
